import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";

import { GET_JOB_DOCUMENTS, UPLOAD_JOB_DOCUMENT, DOWNLOAD_JOB_DOCUMENT, DOWNLOAD_JOB_DOCUMENTS, PREVIEW_JOB_DOCUMENT, REVIEW_JOB_DOCUMENT } from "./actions.type";
import {forceDownload, filePreview} from "@/common/documentFunctions";
import {formatDate} from "../common/formatting"
import constants from "../common/constants"

const JobDocumentModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    documents: {},
    documentsUrl: "/jobdocuments"
  },
  mutations:{
    storeDocuments (state, documentData) {
      state.documents.received = documentData.received;
      state.documents.submitted = documentData.submitted;
    },
    formatDocuments(state) {
      var docUrl = this.getters.getDocumentsUrl + '/';
      var frmtDocs = [];
      //Only two loops received/submitted
      Object.keys(state.documents).forEach( function (docType, key) {
        //docType = received/submitted
        frmtDocs[docType] = [];
        //Loop through each document for given type.
        state.documents[docType].forEach(function(doc, i) {
          let newDoc = {
            data: {
              id: doc.id
            },
            actions: [
              {
                link: docUrl + doc.id,
                icon: 'show'
              },
              {
                name: doc.name,
                link: docUrl + doc.id,
                icon: 'download'
              }
            ],
            dateUploaded: {
              value: formatDate(doc.created_at),
              realValue: doc.created_at
            },
            desc: {
              value: doc.description
            },
            reviewed_comment: {
              value: doc.reviewed_comment
            },
            docName: {
              value: doc.name
            },
            reviewed:{
              id:doc.id,
              value: formatDate(doc.reviewed_date),
              realValue: doc.reviewed_date
            }
          };
          if (doc.user) {
              const deletedUserLabel = doc.user.is_deleted ? ' (deleted user)' : '';
              const uploadedBy = `${doc.user.first_name} ${doc.user.last_name}${deletedUserLabel}`;
              newDoc.uploadedBy = {value: constants.updateUploadedBy(doc.description, uploadedBy)};
          } else if (doc.hasOwnProperty('user')) {
              newDoc.uploadedBy = {value: 'Deleted user'};
          }
          frmtDocs[docType].push(newDoc);
        });
      });
      state.documents.received = frmtDocs['received'];
      state.documents.submitted = frmtDocs['submitted'];
    }
  },
  getters: {
    getDocumentsUrl: state => {
      return state.documentsUrl;
    },
    submittedJobDocuments: state => {
      return state.documents.submitted;
    },
    receivedJobDocuments: state => {
      return state.documents.received;
    }
  },
  actions: {
    [GET_JOB_DOCUMENTS](context,payload){
      let currentRole = localStorage.getItem(constants.CURRENT_ROLE);
      return new Promise((resolve,reject)=>{
          ApiService.get('/jobdocuments?jobid=' + payload.jobid+'&role='+currentRole)
            .then(({data}) => {
              this.commit('storeDocuments', data);
              this.commit('formatDocuments');
              resolve();
            })
            .catch(error => {
              reject(error.response.data);
            });
        }
      );
    },
    [DOWNLOAD_JOB_DOCUMENT](context,payload){
      return new Promise((resolve,reject)=>{
        let url = payload.url;
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then(response => {
            forceDownload(response);
            resolve();
          })
          .catch( response => {
            console.log(response);
          });
      });
    },
    [DOWNLOAD_JOB_DOCUMENTS](context,payload){
      return new Promise((resolve,reject)=>{
        let url = this.getters.getDocumentsUrl + '/bulk?';
        for (let id of payload.selectedIds) {
          url += `ids[]=${id}&`
        }
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then(response => {
            forceDownload(response);
            resolve();
          })
          .catch( response => {
            console.log(response);
          });
      });
    },
    [PREVIEW_JOB_DOCUMENT](context,payload){
      let url = payload.url;
      return new Promise((resolve,reject)=>{
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then( response => {
            resolve(filePreview(response));
          })
          .catch( response => {
            console.log(response);
          });
      });
    },
    [UPLOAD_JOB_DOCUMENT](context,payload){
      return new Promise((resolve,reject)=>{
          var formData = new FormData();
          formData.append('file', payload.file);
          formData.append('jobId', payload.jobId);
          formData.append('description', payload.description);
          let currentRole = localStorage.getItem(constants.CURRENT_ROLE);
          formData.append('role', currentRole);
          ApiService.post("/jobdocuments", formData)
            .then(({ data }) => {
                resolve( {
                  success: false,
                  error: data
                });
            })
            .catch(({ response }) => {
              var err = response.data;
              var errMsg = err.message;
              if (err.data) {
                for (let p in err.data) {
                  if (Object.prototype.hasOwnProperty.call(err.data, p)) {
                    errMsg += ` ${err.data[p]}`;
                  } else {
                    errMsg += ` ${p}`;
                  }
                }
              };
              reject({
                success: false,
                error: errMsg
              });
            })
        }
      );
    },
    [REVIEW_JOB_DOCUMENT](context,payload){
      let url = this.getters.getDocumentsUrl;
      return new Promise((resolve,reject) => {
        ApiService.put(url + '/' + payload.reviewId,{'reviewed_comment':payload.reviewComment})
          .then(({data}) => {
              resolve(data)
          })
          .catch(error => {
            reject(error)
          });
      });
    }
  }
};

export default JobDocumentModule;
